import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import { canUserDispute } from "./utils";

interface DisputeMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const DisputeMovement: React.FC<DisputeMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData || !movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserDispute(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.from,
    movementFlowData.status,
  );
  const handleDisputeClick = () => {
    openDrawer("disputeDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canDisputeMovementService"
      isActionAvailable={isActionAvailable}
      onReject={handleDisputeClick}
    />
  );
};
export default DisputeMovement;
